import { useAuthContext } from "../Contexts/AuthProvider";

import styles from "../Channel/Channels.module.css";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import GradientLine from "./GradientLine";
import { useMsal } from "@azure/msal-react";
import { useGetAltSite } from "../Hooks/useNavigateAltSite";
import NavigateHome from "../NavigateHome";

const Header = () => {
  const { instance: msalInstance } = useMsal();
  const navigate = useNavigate();
  const getAltSite = useGetAltSite();
  const [menuOpen, setMenuOpen] = useState(false);

  const { signOut } = useAuthContext();

  const handleNavigateAlt = () => {
    setMenuOpen(false);

    window.location.href = getAltSite();
  }

  const handleSignOut = async () => {
    setMenuOpen(false);

    if (msalInstance.getActiveAccount()) {
      navigate('/auth/ms/logout');
    } else {
      await signOut();
      NavigateHome();
    }
  }

  return (
    <>
      <GradientLine />

      <header className={styles["header"]}>
        <div className={styles["header-inner"]}>
          <a href={getAltSite()} className={styles["logo"]} onClick={() => navigate('/')}><span className={styles["l"]}>[</span>VACTORS<span className={styles["r"]}>]</span></a>
          <div className={styles["header-actions"]}>
            <a className={[styles["open-web-app"], styles["desktop-open-web-app"]].join(' ')} onClick={handleNavigateAlt}>Open Web App</a>
            <button className={styles["main-menu-button"]} id="mainMenuButton" type="button" aria-label="Open menu" onClick={() => setMenuOpen(!menuOpen)}>☰</button>
            {menuOpen &&
              <div className={styles["main-menu"]} id="mainMenu" aria-hidden="true">
                <a className={styles["mobile-open-web-app"]} onClick={handleNavigateAlt}>Open Web App</a>
                <button type="button" id="menuHistory" onClick={() => navigate('/history')}>History</button>
                <a target="_blank" href="https://www.vactors.club/Contact">Contact Us</a>
                <button type="button" onClick={handleSignOut}>Log Out</button>
              </div>
            }
          </div>
        </div>
      </header>
    </>
  )
}

export default Header;
